import api from '@/api/index'
import axios from 'axios'

const state = {
    user: {},
    token: '',
    status: sessionStorage.getItem('token') || ''
}

const actions = {
    Login ({ commit }, user) {
        return new Promise((resolve, reject) => {
            console.log("Запрос авторизации на API")
            api.Auth.login(user).then(response => {
                if (response.Token) {
                    console.log("Получен ответ - успешно")
                    sessionStorage.setItem('loginType', response.LoginType)
                    sessionStorage.setItem('token', response.Token)
                    sessionStorage.setItem('companyId', response.CompanyId)
                    sessionStorage.setItem('customerId', response.CustomerId)
                    sessionStorage.setItem('companyName', (response.CompanyName ? response.CompanyName : ''))
                    sessionStorage.setItem('contentModules', response.ContentModules)
                    resolve(response)
                }
                else {
                    console.log("Получен ответ - ошибка")
                    reject(response.ErrorString)
                    commit('auth_error')
                    sessionStorage.removeItem('token')
                }
            }).catch(() => {
                console.log("Нет подключения к серверу")
                reject('Ошибка подключения к серверу управления. Повторите попытку позже.')
                commit('auth_error')
                sessionStorage.removeItem('token')
            })
        })
    },
    GetInfo ({ commit }) {
        let token = sessionStorage.getItem('token')

        return new Promise((resolve, reject) => {
            if (!token) {
                commit('logout')
                reject('Error')
            }
            else {
                api.Auth.getUser().then((response) => {

                    if (response.Name == 'SessionInfo') {
                        sessionStorage.setItem('customerId', response.CustomerId)

                        let data = {
                            token: token,
                            user: {
                                id: response.Id,
                                name: response.CompanyName,
                                role: response.Role,
                                userFio: response.UserFullName
                            }
                        }
                        commit('auth_success', data)
                        resolve('Success')
                    }
                    else {
                        commit('logout')
                        reject('Error')
                    }
                }).catch(() => {
                    commit('logout')
                    reject('Error')
                })
            }
        })
    },
    Logout ({ commit }) {
        return new Promise((resolve) => {
            commit('logout')
            sessionStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
            resolve('ok')
        })

    }
}

const getters = {
    userName: state => (state.user.name) ? state.user.name : ''
}

const mutations = {
    auth_success(state, user) {
        state.status = 'success'
        state.token = user.token
        state.user = user.user
    },
    auth_error(state) {
        state.status = 'error'
    },
    logout(state) {
        state.status = ''
        state.token = ''
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
